module.exports = __webpack_public_path__ + "img/manda_033.2c744cef.png";